import { createSelector } from 'reselect'
import { featureStateSelector } from './featureStateSelector'

export const overviewReportRowsSelector = createSelector(featureStateSelector, state => state.overviewList)

export default overviewReportRowsSelector
